import { UserProfile } from "../../models/user-profile/user-profile.model";

export interface IUserProfileState {
    userProfile: UserProfile | null;
    loading: boolean;
    error: string | null;
}

export const initialUserProfileState: IUserProfileState = {
    userProfile: null,
    loading: false,
    error: null
}
